import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import Icon from 'assets/components/icon/Icon';
import RichTextInput from 'assets/components/inputs/richTextInput/RichTextInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales, Language } from 'assets/locales/Locale';
import { ProviderStatementBalanceEmailTemplateForm } from '../ProviderStatementBalanceEmailTemplate.Edit';
import ProviderStatementBalanceEmailTemplateTags from 'module/management/components/providerStatementBalanceEmailTemplate/ProviderStatementBalanceEmailTemplateTags';

export const ProviderStatementBalanceEmailTemplateEditTranslation = ({
  languageIsoCode,
}: {
  languageIsoCode: Language;
}) => {
  const { lang } = getLocales();
  const { form } = useModalForm<ProviderStatementBalanceEmailTemplateForm>();
  const translations = form.data?.translatedTemplates ?? [];
  const translatedTemplate = translations.find((it) => it.languageIsoCode === languageIsoCode && it.isRemoved !== true);
  const translationExists = !!translatedTemplate;

  function handleAdd() {
    const updated = [...translations];
    updated.push({
      entityType: 'ProviderStatementBalanceEmailTemplate',
      languageIsoCode,
      propertyValues: {
        Subject: form.data?.subject,
        HTMLBody: form.data?.htmlBody,
      },
    });
    form.update({ translatedTemplates: updated });
  }

  function handleDelete() {
    const updated = [...translations];
    const index = updated.findIndex((it) => it.languageIsoCode === languageIsoCode && it.isRemoved !== true);
    if (index >= 0) {
      const translation = updated[index];
      if (translation.id) {
        updated[index] = {
          ...translation,
          isRemoved: true,
        };
      } else {
        updated.splice(index, 1);
      }
    }
    form.update({ translatedTemplates: updated });
  }

  function handleChange(key: 'Subject' | 'HTMLBody', value: string) {
    const updated = [...translations];
    const index = updated.findIndex((it) => it.languageIsoCode === languageIsoCode && it.isRemoved !== true);
    if (index < 0) return;
    updated[index] = {
      ...updated[index],
      propertyValues: {
        ...updated[index].propertyValues,
        [key]: value,
      },
    };
    form.update({ translatedTemplates: updated });
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>{lang[languageIsoCode]}</strong>
        {translationExists ? (
          <Button
            class={ThemeButtonCircle}
            media={<Icon class="fas-trash" />}
            onClick={handleDelete}
            htmlElementProps={{ title: lang.deleteTranslation }}
            render={lang.deleteTranslation}
          />
        ) : (
          <Button
            class={ThemeButtonCircle}
            media={<Icon class="fas-plus" />}
            onClick={handleAdd}
            htmlElementProps={{ title: lang.addTranslation }}
            render={lang.addTranslation}
          />
        )}
      </div>
      {translationExists && (
        <>
          <TextInput
            name="subject"
            label={`${lang[languageIsoCode]} ${lang.subject}`}
            value={translatedTemplate?.propertyValues?.Subject}
            onChange={({ subject }) => handleChange('Subject', subject)}
            icon={<Icon class="if-quill-pen" />}
          />
          <RichTextInput
            key={`${languageIsoCode}-${translatedTemplate?.id ?? 'new'}`}
            name="HTMLBody"
            label={`${lang[languageIsoCode]} ${lang.htmlBody}`}
            value={translatedTemplate?.propertyValues?.HTMLBody}
            onChange={({ HTMLBody }) => handleChange('HTMLBody', HTMLBody)}
            icon={<Icon class="if-quill-pen" />}
            customActions={<ProviderStatementBalanceEmailTemplateTags />}
          />
        </>
      )}
    </div>
  );
};
